import type { StageState } from "../hooks/useLivescoreMatches";

export type BoardView = "loading" | "my-leagues-empty" | "empty" | "unavailable" | "board";
/** The line shown under the board for the second stage, when any. */
export type RestLine = "loading" | "unavailable" | "popular-unavailable" | null;

interface BoardViewInput {
    popular: StageState;
    rest: StageState;
    /** From the hook: every running stage is ready and none has a group. */
    empty: boolean;
    /** my-leagues selected with no favourites saved. */
    myLeaguesEmpty: boolean;
}

/**
 * Which of the livescore page's states to render, from the two stages. Pure, so the
 * combinations are tested: a failed stage is never shown as an empty day, "loading more"
 * never outlives the stage it describes, and "unavailable" appears only once nothing can
 * still arrive.
 */
export function resolveBoardView({ popular, rest, empty, myLeaguesEmpty }: BoardViewInput): {
    view: BoardView;
    restLine: RestLine;
} {
    if (myLeaguesEmpty) return { view: "my-leagues-empty", restLine: null };
    const popularBare = popular.groups.length === 0;
    const restBare = rest.groups.length === 0;
    const restRunning = rest.status !== "idle";

    if (popular.status === "loading" && popularBare && (!restRunning || restBare))
        return { view: "loading", restLine: null };
    if (empty) return { view: "empty", restLine: null };
    if (popular.status === "failed" && popularBare) {
        if (!restRunning || (rest.status === "failed" && restBare)) return { view: "unavailable", restLine: null };
        if (rest.status === "loading" && restBare) return { view: "loading", restLine: null };
        return { view: "board", restLine: "popular-unavailable" };
    }
    if (restRunning && restBare) {
        if (rest.status === "loading") return { view: "board", restLine: "loading" };
        if (rest.status === "failed") return { view: "board", restLine: "unavailable" };
    }
    return { view: "board", restLine: null };
}
